import React from 'react';
import { Box, Stack } from '@mui/material';
import { CommentCard } from './CommentCard';
import { useComments } from './useComments';
import { CommentsCardsProps } from './types';
import { COMMENTS_STYLES } from './styles';
import { MOCK_COMMENTS } from './data';

export const CommentsCards: React.FC<CommentsCardsProps> = ({
  comments = MOCK_COMMENTS,
  maxWidth = 1280,
  className
}) => {
  const { processedComments } = useComments(comments);

  return (
    <Box 
      className={className}
      sx={{
        ...COMMENTS_STYLES.container,
        maxWidth: maxWidth,
      }}
      role="region"
      aria-label="User testimonials and comments"
    >
      <Stack 
        direction={{ xs: "column", md: "row" }}
        spacing={{ xs: 2, md: 3 }}
        sx={COMMENTS_STYLES.stack}
      >
        {processedComments.map((comment) => (
          <CommentCard
            key={comment.id}
            comment={comment}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default CommentsCards;
